import Carousel from 'react-bootstrap/Carousel';

import CurlyHairConditioner from '../../Assets/Projects/HD/Curly-Hair-Free-Conditioner.webp';
import CurlyHairShampoo from '../../Assets/Projects/HD/Curly-Hair-Free-Shampoo.webp';

import 'animate.css';

function CarouselFadeCurly() {
  const customCarouselItemStyle = {
    display: 'flex',
    flexDirection: 'row', // Display in a row layout
    alignItems: 'center', // Center vertically
  };

  const customImageStyle = {
    marginRight: '10px', // Create some space between the image and caption
  };

  const customCaptionStyle = {
    flex: '1', // Take up remaining horizontal space

    borderBottomLeftRadius: '80px 80px',
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    color: 'white',
    padding: '10px',
    marginLeft: '-50px',
    borderLeftRadius: '20rem', // Overlap the image slightly to the left
  };

  return (
    <Carousel fade controls={false} indicators={false}>
      <Carousel.Item style={customCarouselItemStyle}>
        <img
          src={CurlyHairConditioner}
          alt=""
          width={200}
          height={300}
          className="image-border-glow-or border-rounded p-2 m-2"
          style={customImageStyle}
          loading="lazy"
        />
        <div style={customCaptionStyle}>
          <h3 className="animate__animated animate__zoomIn">
            Curly Hair Free Sulphate Conditioner
          </h3>
          <p>
            For Curly Hair Developed to Condition & Enhance Curls Natural
            Ingredients
          </p>
        </div>
      </Carousel.Item>
      <Carousel.Item style={customCarouselItemStyle}>
        <img
          src={CurlyHairShampoo}
          alt=""
          width={200}
          height={300}
          className="image-border-glow-or border-rounded p-2 m-2"
          style={customImageStyle}
          loading="lazy"
        />
        <div style={customCaptionStyle}>
          <h3 className="animate__animated animate__zoomIn">
            Curly Hair Free Sulphate Shampoo
          </h3>
          <p>
            for Curly Hair Developed to Condition & Enhance Curls Natural
            Ingredients Sulphate Free
          </p>
        </div>
      </Carousel.Item>
    </Carousel>
  );
}

export default CarouselFadeCurly;
